import {
  Dropdown,
  DropdownProps,
  Label,
  makeStyles,
  Button,
} from "@fluentui/react-components";
import { Dismiss20Regular } from "@fluentui/react-icons";
import React from "react";

const useStyles = makeStyles({
  container: {
    position: "relative",
    display: "flex",
    alignItems: "center",
  },
  dropdown: {
    flexGrow: 1,
  },
  clearButton: {
    position: "absolute",
    right: "32px",
    zIndex: 1,
    minWidth: "24px",
    height: "24px",
    padding: "0",
  },
});

interface ClearableDropdownProps extends Omit<
  DropdownProps,
  "selectedOptions" | "value"
> {
  selectedOptions?: string[];
  value?: string;
  onClear: () => void;
  label?: React.ReactNode;
}

export const ClearableDropdown: React.FC<ClearableDropdownProps> = ({
  selectedOptions,
  value,
  onClear,
  label,
  children,
  ...dropdownProps
}) => {
  const classes = useStyles();
  const showClearButton = selectedOptions && selectedOptions.length > 0;

  const handleClear = (e: React.MouseEvent) => {
    e.stopPropagation();
    onClear();
  };

  return (
    <div>
      {label && <Label>{label}</Label>}
      <div className={classes.container}>
        <Dropdown
          {...dropdownProps}
          selectedOptions={selectedOptions || []}
          value={value || ""}
          className={classes.dropdown}
        >
          {children}
        </Dropdown>
        {showClearButton && (
          <Button
            appearance="subtle"
            icon={<Dismiss20Regular />}
            onClick={handleClear}
            className={classes.clearButton}
            aria-label="Clear selection"
          />
        )}
      </div>
    </div>
  );
};
